import React from "react";
import AddFavouriteModal from "./AddFavouriteModal";
import EditFavouriteModal from "./EditFavouriteModal";
import ShareQueryModal from "./ShareQueryModal";
import QuickSearchModal from "./QuickSearchModal";
import { removeLabelFromSearchSelections } from "../../util";
import { SEARCH_MODALS_NAMES } from "../../hooks/useSearchModals";
import DeleteFavouriteModal from "./DeleteFavouriteModal";
import { ISearchModalProps } from "./@types/SearchModals";

const SearchModals = ({
  name,
  searchValue,
  favoriteQuery,
  onBulkSearch,
  onSearch,
  onHistoryAndFavoritesSearch,
  onSuggestionSearch,
  onClose
}: ISearchModalProps) => {
  if (name === SEARCH_MODALS_NAMES.ADD_FAVOURITE) {
    return (
      <AddFavouriteModal
        onClose={onClose}
        searchValue={{
          q: searchValue?.q,
          selections: searchValue?.selections,
          location: searchValue?.location
        }}
      />
    );
  }
  if (name === SEARCH_MODALS_NAMES.EDIT_FAVOURITE && favoriteQuery) {
    return (
      <EditFavouriteModal
        id={favoriteQuery?.id}
        name={favoriteQuery?.name}
        content={favoriteQuery?.content}
        onClose={onClose}
      />
    );
  }
  if (name === SEARCH_MODALS_NAMES.SHARE_QUERY) {
    return (
      <ShareQueryModal
        query={searchValue?.q}
        selections={removeLabelFromSearchSelections(searchValue?.selections)}
        location={searchValue?.location}
        onClose={onClose}
      />
    );
  }
  if (
    [
      SEARCH_MODALS_NAMES.QUICK_SEARCH,
      SEARCH_MODALS_NAMES.SUGGESTIONS
    ].includes(name ?? "")
  ) {
    return (
      <QuickSearchModal
        show
        initialActiveTab={
          name === SEARCH_MODALS_NAMES.SUGGESTIONS ? "suggestions" : undefined
        }
        onClose={onClose}
        onBulkSearch={onBulkSearch ?? (() => {})}
        onSearch={onSearch ?? (() => {})}
        onHistoryAndFavoritesSearch={onHistoryAndFavoritesSearch}
        onSuggestionsSearch={onSuggestionSearch}
      />
    );
  }
  if (name === SEARCH_MODALS_NAMES.DELETE_FAVOURITE && favoriteQuery) {
    return (
      <DeleteFavouriteModal
        id={favoriteQuery?.id}
        name={favoriteQuery?.name}
        onClose={onClose}
      />
    );
  }
  console.warn(`Unrecognized modal name ${name}`);
  return null;
};

export default SearchModals;
